/**
 * Stats Slider
 * -----------------------------------------------------------------------------
 */

// Imports
const $ = require( 'jquery' );
const {
  BREAKPOINT_SM,
  BREAKPOINT_MD
} = require( '../utilities/_constants' );




function StatsSlider() {

  const $statsSlider = $( '.stats-slider' ).map( ( i, el ) => $( el ) );

  function init( $el ) {

    const $sliderContainer = $el.find( '.stats--slider' );

    $sliderContainer.slick( {

      slidesToShow: 3,
      labelPrevArrow: 'Previous Stat',
      labelNextArrow: 'Next Stat',
      responsive: [
      {
        breakpoint: BREAKPOINT_MD,
        settings: {
          slidesToShow: 2
        }
      }, {
        breakpoint: BREAKPOINT_SM,
        settings: {
          slidesToShow: 1
        }
      } ]

    } );
  
  }

  if ( !$statsSlider.length ) {
    return;
  }

  // Load the slick script
  import( 'accessible_slick_script' )
    .then( ( res ) => {
      
      $statsSlider.map( ( i, $el ) => {
        init( $el );
      });

    } )
  .catch( ( e ) => console.log( e ) );
  
}

StatsSlider();
